/////////////////////////////////////////////////////////////////////////////////////////////////////////
//  컴포넌트명 : ChatPendingFiles (전송 대기 중인 첨부파일 목록)
//  설명 : 상담톡 입력창/상담요청 폼에서 아직 전송하지 않은 첨부파일을 칩으로 보여줌. 이미지 파일(붙여넣은 화면캡처 포함)은
//        파일 아이콘 대신 작은 썸네일을 보여줘서 전송 전에 내용을 알아보고 지울 수 있게 함.
//  개발이력 : 2026.09.20  최초개발(이미지 붙여넣기 지원과 함께 ChatRoom/ChatRequestForm의 중복 칩 코드를 공통화)
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from 'react';
import '../styles/chatDesk.css'; // 상담톡 전용 스타일
import ImageLightbox from './ImageLightbox'; // 이미지 확대 미리보기
import { formatFileSize, getFileIcon } from '../utils/commonUtils'; // 첨부파일 아이콘/용량표시 공통 유틸

const PendingChip: React.FC<{ file: File; onRemove: () => void }> = ({ file, onRemove }) => {
  const [thumb, setThumb] = useState('');
  const [preview, setPreview] = useState(false); // 썸네일 클릭 시 확대 미리보기
  useEffect(() => {
    if (!file.type.startsWith('image/')) return;
    const url = URL.createObjectURL(file);
    setThumb(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);
  return (
    <span className={`chatDesk-chip${thumb ? ' has-thumb' : ''}`}>
      {thumb ? <img className="chatDesk-chip-thumb" src={thumb} alt="" title="클릭하면 크게 봅니다" onClick={() => setPreview(true)} /> : <i className={`fas ${getFileIcon(file.name).icon}`} />}
      <span>{file.name} ({formatFileSize(file.size)})</span>
      <button type="button" onClick={onRemove} title="제거"><i className="fas fa-times" /></button>
      {preview && thumb && <ImageLightbox src={thumb} name={file.name} onClose={() => setPreview(false)} />}
    </span>
  );
};

interface ChatPendingFilesProps {
  files: File[];
  onRemove: (file: File) => void;
}

const ChatPendingFiles: React.FC<ChatPendingFilesProps> = ({ files, onRemove }) => {
  if (files.length === 0) return null;
  return (
    <div className="chatDesk-pending">
      {files.map(f => <PendingChip key={`${f.name}_${f.size}_${f.lastModified}`} file={f} onRemove={() => onRemove(f)} />)}
    </div>
  );
};

export default ChatPendingFiles;
